'use client'
import * as React from 'react'

import { createContext } from '~logic/lib/react'
import { TStorage } from '~types/TStorage'

const [Provider, useStorageCtx] = createContext<TStorage>(`Storage`)

type TProps = RequiredChildren & {
  storage: TStorage
}

/**
 * provider of the storage access
 * use the `useStorage` hook to access that storage instance
 */
export const StorageProvider: React.FC<TProps> = ({ children, storage }) => {
  return <Provider value={storage}>{children}</Provider>
}

export { useStorageCtx }
